import {Col, Select} from 'antd';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import React, {useId, useRef} from 'react';
import {fieldColProps} from '../gridHelpers';

const SelectBox = (props: any) => {
  const {formikProp} = props;
  const selectField: any = props.field;
  const customEvents: any = props.customEvents
    ? props.customEvents[selectField.name] && props.customEvents[selectField.name]
    : {};

  const options = selectField.options?.map((option) => ({
    label: option?.text,
    value: option?.value,
  }));

  // Type-to-jump (opt-in via `jumpToLetter`): with the list open, pressing a
  // letter scrolls to and highlights the first option starting with it;
  // pressing the same letter again cycles to the next match. Enter selects it.
  const popupClass = `select-popup-${useId().replace(/:/g, '')}`;
  const lastJump = useRef<{key: string; index: number}>({key: '', index: -1});
  const handleLetterJump = (e: React.KeyboardEvent) => {
    if (!selectField.jumpToLetter || e.key.length !== 1 || !/[a-z]/i.test(e.key)) return;
    const popup = document.querySelector(`.${popupClass}`);
    if (!popup) return;
    const key = e.key.toLowerCase();
    const items = Array.from(
      popup.querySelectorAll<HTMLElement>(
        '.ant-select-item-option:not(.ant-select-item-option-disabled)',
      ),
    ).filter((el) =>
      (el.getAttribute('title') || el.textContent || '').trim().toLowerCase().startsWith(key),
    );
    if (!items.length) return;
    const next = lastJump.current.key === key ? (lastJump.current.index + 1) % items.length : 0;
    lastJump.current = {key, index: next};
    items[next].scrollIntoView({block: 'nearest'});
    // rc-select marks the hovered option as active, so Enter picks this one.
    items[next].dispatchEvent(new MouseEvent('mousemove', {bubbles: true}));
    e.preventDefault();
  };

  const hasError = Boolean(
    (formikProp.touched[selectField?.name] || formikProp.submitCount > 0) &&
      formikProp.errors[selectField?.name],
  );

  return (
    <Col {...fieldColProps(selectField)}>
      <FieldLabel field={selectField} />
      <Select
        disabled={selectField.isDisabled ?? false}
        status={hasError ? 'error' : undefined}
        style={{width: '100%'}}
        value={formikProp.values[selectField?.name] ?? undefined}
        options={options}
        virtual={selectField.virtual ?? true}
        classNames={{popup: {root: popupClass}}}
        onKeyDown={handleLetterJump}
        onBlur={() => formikProp.setFieldTouched(selectField.name, true)}
        onChange={(value) => {
          formikProp.setFieldValue(selectField.name, value);
          customEvents &&
            customEvents.onChange &&
            customEvents['onChange'](
              {target: {name: selectField.name, value}},
              formikProp.setFieldValue,
              formikProp.values,
            );
        }}
      />
      <FieldError name={selectField.name} />
    </Col>
  );
};

export default SelectBox;
